export enum ComplianceElementDetails {
  HIDDEN = 'HIDDEN',
  OVERVIEW = 'OVERVIEW',
  FULL = 'FULL',
}
